import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const GuestGuard = ({ children }: any) => {
  const user = useSelector(({ UserSlice }: any) => UserSlice.user);

  if (user.email) {
    return <Navigate to="/" />;
  }

  return <div>{children}</div>;
};

export default GuestGuard;
